export default function extraData () {
  return {
    props: {
      extra: {
        type: String
      },
      extraTariffOptionsData: {
        type: String
      }
    },
    data () {
      return {
        extraData: {},
        parsedTariffOptionsData: {}
      }
    },
    created () {
      try {
        if (this.extra) {
          this.extraData = JSON.parse(atob(this.extra))
        }
      } catch (e) {
        this.extraData = {}
      }

      try {
        if (this.extraTariffOptionsData) {
          this.parsedTariffOptionsData = JSON.parse(atob(this.extraTariffOptionsData))
        }
      } catch (e) {
        this.parsedTariffOptionsData = {}
      }
    }
  }
}
